import React, { useEffect, useRef, useState } from "react";
import { url } from "../config";
import toast from "../utils/toast";
import "../assets/css/resetPassword.css";

const ResetPasswordModal = ({ onClose,onLogout }) => {
  const modalRef = useRef(null);
  const instanceRef = useRef(null);

  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

    // const [showPassword, setShowPassword] = useState({
    //   old: false,
    //   new: false,
    //   confirm: false
    // });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const elem = modalRef.current;

    instanceRef.current = window.M.Modal.init(elem, {
      dismissible: false
    });

    instanceRef.current.open();

    return () => {
      instanceRef.current?.destroy();
    };
  }, []);

  const closeModal = () => {
    instanceRef.current?.close();
    onClose();
  };

      const handleChange = (e) => {
        setForm({
        ...form,
        [e.target.name]: e.target.value
        });
    };

    // const togglePassword = (field) => {
    //     setShowPassword({
    //     ...showPassword,
    //     [field]: !showPassword[field]
    //     });
    // };

  const handleSubmit = async () => {
    if (!form.oldPassword) return toast("Enter old password");
    if (!form.newPassword) return toast("Enter new password");
    if (form.newPassword !== form.confirmPassword)
      return toast("Passwords do not match");

    setLoading(true);
    let mobile = localStorage.getItem("mobile");
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        body: new URLSearchParams({
          workforce: "changePassword",
          oldPassword: form.oldPassword,
          newPassword: form.newPassword,
          mobile:mobile
        }),
      });

      const data = await res.json();

      if (data.Result === 1) {
        toast("Password updated", "success");
        closeModal();
        onLogout();
      } else {
        toast(data.Message || "Failed");
      }
    } catch {
      toast("Error occurred");
    }

    setLoading(false);
  };

  return (
        <div className="modal reset-password-modal" ref={modalRef}>

        
            <div className="modal-header" style={{ padding: "10px",color:"black" }}>
                            <h5 className="modal-title">
                            <span className="left">Reset Password</span>
                            <i className="material-icons right" style={{ cursor: "pointer","fontWeight": "bolder",lineHeight: "1" }} onClick={closeModal}>
                                close
                            </i>
                            </h5>
            </div>

            <div className="modal-content" style={{marginTop:"15px"}}>
                
                {/* Old Password */}
                <div className="password-field">
                    <div className="input-field">
                    <label htmlFor="oldPassword">Old Password</label>
                <input
                    type="password"
                    name="oldPassword"
                    id="oldPassword"
                    value={form.oldPassword}
                    onChange={handleChange}
                    required
                />

                    </div>


                </div>

                {/* New Password */}
                <div className="password-field">
                <div className="input-field">
                <label htmlFor="newPassword">New Password</label>
                <input
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    value={form.newPassword}
                    onChange={handleChange}
                    required
                />

                </div>
                </div>

                {/* Confirm Password */}
                <div className="password-field">
                    <div className="input-field">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    required/>

                    </div>
                </div>

            </div>

            <div className="modal-footer reset-footer">

                <button
                className="btn-login"
                onClick={handleSubmit}
                disabled={loading}
                >
                    UPDATE
                {loading ? (
                    <>
                    <span className="spinner"></span>
                    </>
                ) : (
                    ""
                )}
                </button>

            </div>

        </div>
  );
};

export default ResetPasswordModal;

